
import React from "react";
import { Box, Typography, TextField } from "@material-ui/core";
import Button from "storybookComponents/Button"
import Modal from "components/Modal";

export default ({ title, open, toggler, children, cancelText, actionText, classes, action }) => (
  <Modal
    open={open}
    maxWidth="sm"
    title={title}
    actionChildren={
      <>
        <Button color="darkBlack" variant="tertiary" size="md" onClick={() => toggler(false)}>
          No
        </Button>
        <Button color="hylyBlue" type="submit" variant="primary" size="md" onClick={action}>
          <strong>Yes</strong>
        </Button>
      </>
    }
  >
    {children}
  </Modal>
)